import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Text } from '../../shared/uiComponents';
import { InfoRow } from '../StyledComponents';

import { DispatchProperties, useSelector } from '../../redux/store';
import { getUserActiveAllocations } from '../../redux/State/userSlice/userSessionAllocationSlice';

const NonBillableHours = ({ userId }: { userId: string }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const activeAllocation = useSelector((state) => state.userSessionAllocation.userActiveAllocations);

	useEffect(() => {
		if (!userId) return;
		dispatch(getUserActiveAllocations(userId));
	}, [userId, dispatch]);

	if (!activeAllocation || activeAllocation.length === 0) return null;

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			{activeAllocation.map((allocation) => (
				<>
					<InfoRow>
						<Text title="Unbillable Hours: " type="psm" fontWeight="semiBold" />
						<Text title={`${allocation.hoursPerMonth}/month`} />
					</InfoRow>
					{allocation.modifiedByFullName && (
						<InfoRow>
							<Text title="Modified by: " type="psm" fontWeight="semiBold" />
							<Text title={allocation.modifiedByFullName} />
						</InfoRow>
					)}
					{allocation.deletedByFullName && (
						<InfoRow>
							<Text title="Deleted by: " type="psm" fontWeight="semiBold" />
							<Text title={allocation.deletedByFullName} />
						</InfoRow>
					)}
				</>
			))}
		</div>
	);
};

export default NonBillableHours;
